import React from "react";
import Button from "@insightfulscience/atomic-react/Button";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Html from "@insightfulscience/smart-react/Html";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import { useLocale } from "@insightfulscience/smart-react/i18";
import Block from "@insightfulscience/atomic-react/Block";
import {
	GoogleRecaptchaNotice,
	CastleNotice,
	useFormActionWithAnyCaptcha,
} from "@insightfulscience/smart-react/anyCaptcha";
import Alert from "@insightfulscience/atomic-react/Alert";

import { initialState, validateForm } from "./form";
import { signUpFormAction, EALREADY_EXISTS_CUSTOMER, EINVALID_PASSWORD_STRENGTH } from "./action";
import routes from "../routes";
import { publicConfig } from "../config";

function SignUpFrom() {
	const [t] = useLocale("registration-form");

	const [action, { isLoading, error, reset, type }] = useFormActionWithAnyCaptcha(
		signUpFormAction,
		{
			endOn: "then",
			googleRecaptchaSiteKey: publicConfig.GOOGLE_RECAPTCHA_SITE_KEY,
			castlePublicKey: publicConfig.CASTLE_PUBLIC_KEY,
			action: "signUp",
		},
	);

	return (
		<>
			{isLoading && <Spinner />}
			{!!error && ![EALREADY_EXISTS_CUSTOMER, EINVALID_PASSWORD_STRENGTH].includes(error) && (
				<Alert status="error" className="mb-4">
					{t(error)}
				</Alert>
			)}
			<SmartForm textRender={t} {...{ initialState, validateForm, action }} onTouched={reset}>
				<SmartForm.Field
					label="FIRST_NAME"
					name="firstName"
					disabled={isLoading}
					fieldClassName="mb-8"
					maxLength={50}
					required
					data-qa-selector="signUp-first-name-input"
				/>

				<SmartForm.Field
					label="LAST_NAME"
					name="lastName"
					disabled={isLoading}
					fieldClassName="mb-8"
					maxLength={50}
					required
					data-qa-selector="signUp-last-name-input"
				/>

				<SmartForm.Field
					label="COMPANY_NAME"
					name="company"
					disabled={isLoading}
					fieldClassName="mb-8"
					maxLength={50}
					data-qa-selector="signUp-company-input"
				/>

				<SmartForm.Field
					label="EMAIL"
					name="email"
					type="email"
					disabled={isLoading}
					error={error === EALREADY_EXISTS_CUSTOMER && error}
					fieldClassName="mb-8"
					maxLength={100}
					required
					data-qa-selector="signUp-email-input"
				/>

				<SmartForm.Field
					label="PASSWORD"
					name="password"
					type="password"
					disabled={isLoading}
					error={error === EINVALID_PASSWORD_STRENGTH && error}
					fieldClassName="mb-8"
					maxLength={73}
					required
					data-qa-selector="signUp-password-input"
				/>

				<SmartForm.Field
					label="CONFIRM_PASSWORD"
					name="pswdConfirm"
					type="password"
					disabled={isLoading}
					fieldClassName="mb-8"
					maxLength={73}
					required
					data-qa-selector="signUp-password-confirm-input"
				/>

				<Row>
					<Col spacing={{ mt: 4, mb: 2 }}>
						<Block sx={{ textAlign: "center" }}>
							<Button type="submit" disabled={isLoading} data-qa-selector="signUp-submit-button">
								{t("GET_STARTED")}
							</Button>
						</Block>
					</Col>
				</Row>
			</SmartForm>

			<Row>
				<Col>
					<Html Tag="p" className="text-xs text-color-black--40">
						{t("USER_LEGAL_CONCENT", {
							tosLink: routes.external.termsOfService,
							ppLink: routes.external.privacyPolicy,
						})}
					</Html>
				</Col>
			</Row>

			{!!type && (
				<Row>
					<Col>
						{type === "google-recaptcha" && <GoogleRecaptchaNotice />}
						{type === "castle" && <CastleNotice />}
					</Col>
				</Row>
			)}
		</>
	);
}

export default SignUpFrom;
